module.exports = __webpack_public_path__ + "img/arrcouvItal1ere.bcebd6fb.png";